import React from 'react';
import { Reveal } from './Reveal';
import { PriceOffer } from './PriceOffer';
import { volumes, bonuses } from '../data/content';
export function InsideSection() {
  return <section className="w-full bg-navy-800 py-1 lg:py-20" aria-labelledby="inside-heading" data-id="element-79" data-mp="3jz4nk3oe3kd8">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-80" data-mp="3jxabzfz0d4lt">
        <Reveal className="max-w-3xl" data-id="element-81" data-mp="3owwr5uyecux9">
          <p className="text-sm font-bold uppercase tracking-widest text-brand-gold" data-id="element-82" data-mp="3ovv1olgmw5w0">The library</p>
          <h2 id="inside-heading" className="mt-3 text-3xl font-black leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl" data-id="element-83" data-mp="3a3a10xh1p556">
            Here&rsquo;s exactly what you&rsquo;re getting
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-slate-300" data-id="element-84" data-mp="35zc2anvmtwcn">
            Five operational volumes, 800+ pages, sequenced so the highest-return work comes first.
          </p>
        </Reveal>

        <ul className="mt-10 grid grid-cols-1 gap-x-10 lg:grid-cols-2" data-id="element-85" data-mp="147yv1s66zcdf">
          {volumes.map((volume, i) => <li key={volume.n} className="border-t border-white/10" data-id="element-86" data-mp="2zw1tyha35run" data-mpi={i}>
              <Reveal delay={i * 0.04} data-id="element-87" data-mp="2zu8lqxjtqzkj">
                <article className="py-4" data-id="element-88" data-mp="2vuzvw3rwnlu9">
                  <div className="flex items-start gap-3" data-id="element-89" data-mp="2vtyhbpbokh7s">
                    <img src={volume.image} alt={`Cover of ${volume.title}`} className="h-[88px] w-16 shrink-0 rounded-md object-cover ring-1 ring-white/15 sm:h-24 sm:w-[72px]" width={144} height={192} loading="lazy" data-id="element-90" data-mp="39medq7a2tgzq" />
                    <div className="min-w-0 flex-1" data-id="element-91" data-mp="2gy8s7ib77nyu">
                      <p className="text-[10px] font-bold uppercase tracking-[0.18em]" style={{
                    color: volume.color
                  }} data-id="element-92" data-mp="2cvlxn9n57oxy">
                        Vol {volume.n} · {volume.pages}
                      </p>
                      <h3 className="mt-1 text-[15px] font-extrabold uppercase leading-tight tracking-tight text-white sm:text-base" data-id="element-93" data-mp="2lw0t31ttmkf6">
                        {volume.title}
                      </h3>
                      <p className="mt-1.5 text-[12.5px] leading-[1.45] text-slate-300" data-id="element-94" data-mp="150323xceolc">{volume.description}</p>
                    </div>
                  </div>
                </article>
              </Reveal>
            </li>)}
        </ul>

        <Reveal className="mt-10" data-id="element-95" data-mp="d6jcba6ub1bp">
          <PriceOffer data-id="element-96" data-mp="i7p5f94ewqlr" />
        </Reveal>

        <div className="my-[26px] border-t border-white/10 py-0 lg:mb-0 lg:mt-16 lg:pt-12" data-id="element-97" data-mp="i8qre8myuxi9">
          <Reveal className="max-w-3xl" data-id="element-98" data-mp="n57fj2u61bvc">
            <h3 className="text-2xl font-black tracking-tight text-white sm:text-3xl" data-id="element-99" data-mp="n464uzh2are5">
              Plus 5 exclusive bonuses{' '}
              <span className="align-middle text-sm font-bold uppercase tracking-widest text-brand-gold" data-id="element-100" data-mp="3qmpnda9xuivr">
                Limited time
              </span>
            </h3>
            <p className="mt-3 text-lg leading-relaxed text-slate-300" data-id="element-101" data-mp="3vkity4f5lewk">
              $147 of additional assets, included free with the system today.
            </p>
          </Reveal>

          <ul className="mt-6 grid grid-cols-1 gap-x-10 lg:grid-cols-2" data-id="element-102" data-mp="32vk6crs9hkjv">
            {bonuses.map((bonus, i) => <li key={bonus.title} className="border-t border-white/10" data-id="element-103" data-mp="37uoedf3g9c8m" data-mpi={i}>
                <Reveal delay={i * 0.04} data-id="element-104" data-mp="30cq9jnw7qpbq">
                  <article className="py-4" data-id="element-105" data-mp="2ve5iadyxvfzf">
                    <div className="flex items-start gap-3" data-id="element-106" data-mp="2vfgm2dsdwnqj">
                      <img src={bonus.image} alt={`Cover of ${bonus.title}`} className="h-[88px] w-16 shrink-0 rounded-md object-cover ring-1 ring-white/15 sm:h-24 sm:w-[72px]" width={144} height={192} loading="lazy" data-id="element-107" data-mp="2qesn95xwz2lr" />
                      <div className="min-w-0 flex-1" data-id="element-108" data-mp="2hemajma1i6nn">
                        <p className="text-[10px] font-bold uppercase tracking-[0.18em]" style={{
                      color: bonus.color
                    }} data-id="element-109" data-mp="2hg78zmzh69qs">
                          Bonus {i + 1} ·{' '}
                          <span className="font-semibold text-slate-400 line-through decoration-slate-500" data-id="element-110" data-mp="22phuaamt2ci6">{bonus.value}</span>{' '}
                          <span className="text-white" data-id="element-111" data-mp="1xqn2ij6v1dlx">free</span>
                        </p>
                        <h4 className="mt-1 text-[15px] font-extrabold uppercase leading-tight tracking-tight text-white sm:text-base" data-id="element-112" data-mp="1to9z41fl5rsb">
                          {bonus.title}
                        </h4>
                        <p className="mt-1.5 text-[12.5px] leading-[1.45] text-slate-300" data-id="element-113" data-mp="2nesi1gp00tzp">{bonus.description}</p>
                      </div>
                    </div>
                  </article>
                </Reveal>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}